import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { ShieldCheck } from 'lucide-react';
export function PricingCTA() {
  return <Section id="pricing" className="bg-section border-y border-accent-blue/20 relative overflow-hidden" data-id="element-147">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full max-w-[600px] bg-accent-blue/5 blur-[100px] rounded-full pointer-events-none" data-id="element-148" />

      <div className="relative z-10 text-center max-w-3xl mx-auto" data-id="element-149">
        <p className="text-lg text-text-muted line-through mb-2" data-id="element-150">$47 USD</p>
        <h2 className="text-4xl md:text-6xl font-black text-white mb-2" data-id="element-151">
          $6.39 USD
        </h2>
        <p className="text-sm text-accent-yellow font-semibold mb-6" data-id="element-152">
          ¡Descuento aplicado!
        </p>
        <p className="text-xl text-text-secondary mb-8" data-id="element-153">
          Descarga inmediata • Acceso de por vida
        </p>

        <Button className="w-full md:w-auto text-xl px-12 py-6 mb-6 shadow-glow-yellow" onClick={() => window.open('https://www.impulsodigitalexpres.com/cart/49920073662710:1', '_blank')} data-id="element-154">
          QUIERO MI EMBUDO EXPRÉS
        </Button>

        <p className="text-sm text-text-muted mb-8" data-id="element-155">
          Acceso instantáneo. Empieza hoy.
        </p>

        <div className="flex items-center justify-center text-text-secondary text-sm bg-primary/50 inline-flex px-6 py-3 rounded-full border border-white/5" data-id="element-156">
          <ShieldCheck className="w-4 h-4 mr-2 text-green-500" data-id="element-157" />
          Pago seguro y encriptado
        </div>
      </div>
    </Section>;
}